import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    Typography,
    Grid,
    TextField,
    Dialog,
    useMediaQuery,
    IconButton, useTheme
} from '@mui/material'

import {
    CustomControls,
    CustomCounterAppBar,
    DocButton,
    GenericContainer
    , Buttons
} from '../../components'
//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from './DocListStyle'
import { useTranslation } from 'react-i18next';

export default function DocListComponent(props) {
    const matches = useMediaQuery('(max-width:812px)')
    const gridContainer = {} //mainStyles.gridStyle()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.appBarStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()

    const [open, setOpen] = useState(false);
    const [docs, setDocs] = useState([])

    const [fullName, setFullName] = useState('')
    const [fileCode, setFileCode] = useState('')
    const [fileDate, setFileDate] = useState('')
    const [selectedOption, setSelectedOption] = useState('')
    const [options, setOptions] = useState([]);
    const { t } = useTranslation();

    const file = useSelector(state => state.FileInfo)

    useEffect(() => {
        setFullName(file.items.FullName)
        setFileDate(file.items.CreationDateFormatted)
        setFileCode(file.items.Folio)
        setDocs(file.itemsDocs)
        setOptions(file.itemsDocOptions)
    }, [file])



    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const goBack = () => {
        // history.goBack()
    }

    return (<GenericContainer>
        <div className={classes.logoHeaderDocList}>
            <IconButton>
                <ArrowBackIcon className={classes.arrowBack} onClick={goBack} />
            </IconButton>
            <div className={localStyles.barSection}>
                <CustomCounterAppBar viewMenu={false} />
            </div>

        </div>
        <div className={localStyles.avatarInfo}>
            <AccountBoxIcon style={{ color: theme.palette.primary.main, width: '50px', height: '50px' }} />
            <Typography variant="subtitle2" gutterBottom className={localStyles.subTitle2}>{fullName} <HelpIcon style={{ marginLeft: 10 }} onClick={handleClickOpen} /></Typography>
            <Typography variant="subtitle2" gutterBottom><b>{t("info_message_applicant")}</b></Typography>
        </div>
        <Grid className={localStyles.pc12} container spacing={6} >
            <Grid item xs={6}>
                <Typography variant="subtitle2" gutterBottom className={localStyles.title}>{`${t("general_folio")}:`}</Typography>
                <Typography variant="subtitle2" gutterBottom  >{fileCode}</Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="subtitle2" gutterBottom className={localStyles.title}>{`${t("info_message_create")}:`}</Typography>
                <Typography variant="subtitle2" gutterBottom  >{fileDate}</Typography>
            </Grid>
        </Grid>
        <div className={localStyles.filterSection}>
            <TextField
                id="outlined-select-native"
                select
                fullWidth
                label="Documentación"
                SelectProps={{
                    native: true,
                }}
                variant="outlined"
                className={localStyles.inputSelect}
                inputProps={{
                    style: {
                        padding: 12
                    }
                }}
                onChange={(e) => { setSelectedOption(e.target.value) }}
            >
                <option key='select_todos' value='todos'>
                    Todos
                </option>
                {options.map((item) => {
                    return <option key={`select_${item}`} value={item}>
                        {item}
                    </option>
                })}

            </TextField>
            <Dialog fullScreen open={open} onClose={handleClose} className={matches && gridContainer.container}>

                <div className={gridContainer.centerColumn}>
                    <IconButton
                        className={localStyles.closeText}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>

                    <div className={localStyles.infoSection}>
                        <Typography variant="subtitle2" gutterBottom  >Información del crédito</Typography>
                        <Typography className={localStyles.instructions} >La documentación correspondiente a cada actor responde a los siguientes estatus:</Typography>
                        <div className={localStyles.details}>
                            <Typography variant="subtitle2" className={localStyles.approved}>Aprobado.</Typography>
                            <Typography variant="subtitle2">Los documentos han sido proporcionados y aprobados.</Typography>
                        </div>
                        <div className={localStyles.details}>
                            <Typography variant="subtitle2" className={localStyles.rejected}>Rechazado.</Typography>
                            <Typography variant="subtitle2">Algunos de los documentos fueron rechazados durante el proceso, y deben ser proporcionados nuevamente para continuar con la solicitud.</Typography>
                        </div>
                        <div className={localStyles.details}>
                            <Typography variant="subtitle2" className={localStyles.waiting}>En aprobación.</Typography>
                            <Typography variant="subtitle2">Algunos de los documentos faltantes fueron proporcionados, pero se encuentras en espera de aprobación.</Typography>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
        <div className={localStyles.list}>
            {docs.map((document) => {
                if (document.nombre.includes('Firma autógrafa')) {
                    return ''
                } else {
                    if (selectedOption === '' || selectedOption === 'todos') {
                        return <DocButton
                            name={document.nombre}
                            approved={document.validacion === true ? 'Aprobado' : document.validacion === false ? 'Rechazado' : document.validacion === null ? 'En Aprobación' : ''}
                            docStatus={document.validacion === true ? 1 : document.validacion === false ? 2 : document.validacion === null ? 3 : 0}
                            id={document.id} />
                    } else if (selectedOption === document.grupo) {
                        return <DocButton
                            name={document.nombre}
                            approved={document.validacion === true ? 'Aprobado' : document.validacion === false ? 'Rechazado' : document.validacion === null ? 'En Aprobación' : ''}
                            docStatus={document.validacion === true ? 1 : document.validacion === false ? 2 : document.validacion === null ? 3 : 0}
                            id={document.id} />
                    }
                }
            })}
        </div>
    </GenericContainer>)
}